import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-voltar_3d943c8997df58a6cd29c51eac220f4a",
  "use": "ic-voltar_3d943c8997df58a6cd29c51eac220f4a-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ic-voltar_3d943c8997df58a6cd29c51eac220f4a\">\n    <path d=\"M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id